import "@/App.css";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FormContextProvider } from "@/components/context/useFormContext";
import { GeneralForm } from "@/components/forms/generalForm";
import { PartnerForm } from "@/components/forms/partnerForm";
import { CONTACT_GENERAL, CONTACT_PARTNER, CONTACT_SCHOLARSHIP } from "@/lib/constants";
import { ScholarshipForm } from "./components/forms/scholarshipForm";

const queryClient = new QueryClient();

type AppProps = {
	rootElement: HTMLElement;
};

export default function App({ rootElement }: AppProps) {
	const [component, setComponent] = useState<string | undefined>(undefined);
	const [siteTitle, setSiteTitle] = useState<string | undefined>(undefined);
	const [form, setForm] = useState<string | undefined>(undefined);

	useEffect(() => {
		const container = rootElement?.dataset.component;
		const siteTitle = rootElement?.dataset.title;

		switch (container) {
			case "general":
				setForm(CONTACT_GENERAL);
				break;
			case "partner":
				setForm(CONTACT_PARTNER);
				break;
			case "scholarship":
				setForm(CONTACT_SCHOLARSHIP);
				break;
		}

		setSiteTitle(siteTitle);
		setComponent(container);
	}, [rootElement, siteTitle, form]);

	const renderComponent = () => {
		if (form === CONTACT_PARTNER) {
			return <PartnerForm rootId={rootElement} siteTitle={siteTitle} />;
		} else if (form === CONTACT_SCHOLARSHIP) {
			return <ScholarshipForm rootId={rootElement} siteTitle={siteTitle} />;
		} else {
			return <GeneralForm rootId={rootElement} siteTitle={siteTitle} />;
		}
	};

	return (
		<FormContextProvider id={rootElement}>
			<QueryClientProvider client={queryClient}>
				{siteTitle ? renderComponent() : <div>Loading...</div>}
			</QueryClientProvider>
		</FormContextProvider>
	);
}
